module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-form', {
    ref: "reason-form",
    attrs: {
      "resource": _vm.config.api + '/reason/',
      "items": _vm.itemsForm,
      "updateData": _vm.update
    },
    on: {
      "register": _vm.reload
    }
  }), _vm._v(" "), _c('emt-grid', {
    ref: "reason-grid",
    attrs: {
      "resource": _vm.config.api + '/reason_full_data/',
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Motivos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a5c1c9c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-form-reason.vue
// module id = 159
// module chunks = 0